var map = {
	"./icon--arrow-upright.svg": 25,
	"./icon--close.svg": 222,
	"./icon--instagram.svg": 234,
	"./icon--linkedin.svg": 852,
	"./icon--next.svg": 305,
	"./icon--open.svg": 946,
	"./icon--prev.svg": 185,
	"./icon--quote-mark.svg": 24,
	"./icon--speaker-playing.svg": 544,
	"./icon--speaker.svg": 861,
	"./icon--twitter.svg": 811,
	"./logo--headland.svg": 145
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 394;